import { PhoneType } from "../types/phone";
import { prettyPrintEnumValue } from "./prettyPrintEnumValue";

/**
 * Formats a phone number with its type for display.
 * @param phone - The phone number and type to format
 * @returns Formatted string representation of the phone number. ex: "123-456-7890 (24-hour)"
 */
export function prettyPrintPhone(phone: { number?: string | null; type?: PhoneType | null }) {
  if (!phone.number || !phone.type) return "";
  const type = phone.type === PhoneType.Hrs_24 ? "24-hour" : prettyPrintEnumValue(phone.type);
  return `${phone.number} (${type})`;
}
